import EmpCard from "./EmpCard";

const Emp_List = ({ episodeData, episodeId, handleShareData }) => {
  return (
    <ul className="eae_list">
      {episodeData?.map((episode, index) => (
        <li key={index}>
          {episode && (
            <EmpCard episode={episode} handleShareData={handleShareData} />
          )}
        </li>
      ))}
    </ul>
  );
};

export default Emp_List;
